import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import api from "../lib/api";

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const checkAuth = useCallback(async () => {
    try {
      const { data } = await api.get("/auth/me");
      setUser(data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // CRITICAL: if returning from OAuth callback, skip /me check - AuthCallback handles it.
    if (window.location.hash?.includes("session_id=")) { setLoading(false); return; }
    // Nessun token e nessuna sessione precedente: evita la chiamata /auth/me (401 inutile ad ogni apertura del sito)
    if (!localStorage.getItem("es_token") && !localStorage.getItem("es_session")) { setLoading(false); return; }
    checkAuth();
  }, [checkAuth]);

  const setSession = (token, u) => { localStorage.setItem("es_token", token); localStorage.setItem("es_session", "1"); setUser(u); };

  const login = async (email, password, admin = false) => {
    const { data } = await api.post(admin ? "/auth/admin/login" : "/auth/login", { email, password });
    setSession(data.token, data.user);
    return data.user;
  };
  const register = async (payload) => {
    const { data } = await api.post("/auth/register", payload);
    setSession(data.token, data.user);
    return data.user;
  };
  const logout = async () => {
    try { await api.post("/auth/logout"); } catch {}
    localStorage.removeItem("es_token"); localStorage.removeItem("es_session");
    setUser(null);
  };
  const googleLogin = (path) => {
    // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
    const redirectUrl = window.location.origin + path;
    window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, logout, googleLogin, setSession, refresh: checkAuth, loginWithToken: async (token, u) => setSession(token, u) }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
